import config from "../Config/config";

const fetchAllNotificationSettings = async (setNotificationSetting) => {
  try {
    const response = await fetch(`${config.serverBaseUrl}/notifications`, {
      credentials: "include",
    });
    const resJson = await response.json();
    const data = resJson.data;
    setNotificationSetting(data.notificationSettings[0]);
  } catch (error) {
    console.error(`Failed to fetch notification settings: ${error}`);
  }
};

const saveSettings = async (settings, setAlert) => {
  try {
    await fetch(
      `${config.serverBaseUrl}/notifications/${settings.notification_setting_id}`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(settings),
      }
    );
    setAlert({
      severity: "success",
      message: `Settings saved`,
    });
  } catch (error) {
    setAlert({
      severity: "error",
      message: `Failed to save settings: ${error}`,
    });
  }
};

export { fetchAllNotificationSettings, saveSettings };
